// Support email helpers used by the Navbar's contact button.
// Programmatic navigation is more reliable than a plain <a href="mailto:..."> click
// on some mobile webviews.

const SUPPORT_EMAIL = "shane@karmsafety.com";
const SUPPORT_SUBJECT = "KARM Safety Support Request";
const SUPPORT_BODY =
  "Hi KARM Safety team,\n\nI need help with:\n\n— Sent from the KARM Safety App";

export const supportEmail = SUPPORT_EMAIL;

export function buildSupportHref() {
  const params = new URLSearchParams({
    subject: SUPPORT_SUBJECT,
    body: SUPPORT_BODY,
  });
  return `mailto:${SUPPORT_EMAIL}?${params.toString()}`;
}

export function openSupportEmail(e) {
  e?.preventDefault?.();
  try {
    window.location.href = buildSupportHref();
  } catch {
    window.open(buildSupportHref(), "_blank");
  }
}
